<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 公司管理 / 添加公司</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              项目ID
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="project" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              公司名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              公司地址
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="address" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              公司类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="type" class="boxText"/>
              如：能源及重型设备
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              所属行业
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="industry" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              所属地域
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="area" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              曾用名
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="oldName" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              董事长
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="chairman" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              董秘
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="chairmanBorad" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              控股股东
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="konggu" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              实际控制人
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="sjKzr" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              最终控制人
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="zzKzr" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              经营性质
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="businessNature" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              员工人数
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="employee" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              上市日期
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="ssTime" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              最赚钱业务
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="business" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              主营业务
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="workBusiness" class="boxText" style="width: 95%; height: 150px"></textarea>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              收入构成
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="shouru" class="boxText" style="width: 95%; height: 150px"></textarea>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              产品类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="projectType" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              产品名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="projectName" class="boxText"/>
            </td>
          </tr>

          <tr>
            <td class="leftTd">
              经营范围
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="businessScope" class="boxText" style="width: 95%; height: 150px"></textarea>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              公司简介
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="note" class="boxText" style="width: 95%; height: 150px"></textarea>
            </td>
          </tr>


        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button"
               style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white"
               value="添加"/>
        <input @click="goback" type="button"
               style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266"
               value="返回"/>
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddCompany",
  data() {
    return {
      project:"",
      name:"",
      address:"",
      type:"",
      industry:"",
      area:"",
      oldName:"",
      chairman:"",
      chairmanBorad:"",
      konggu:"",
      sjKzr:"",
      zzKzr:"",
      businessNature:"",
      employee:"",
      ssTime:"",
      business:"",
      workBusiness:"",
      shouru:"",
      projectType:"",
      projectName:"",
      businessScope:"",
      note:""
    }
  },
  mounted() {
    let that = this
    if (localStorage.getItem("iwa_token") == null || localStorage.getItem("iwa_token") == "") {
      setTimeout(function () {
        that.$router.replace('index')
      }, 600);
    }

  },
  methods: {
    addAdmin() {
      let that = this
      let json={
        "id":"0",
        "project":this.project,
        "name":this.name,
        "address":this.address,
        "type":this.type,
        "industry":this.industry,
        "area":this.area,
        "oldName":this.oldName,
        "chairman":this.chairman,
        "chairmanBorad":this.chairmanBorad,
        "konggu":this.konggu,
        "sjKzr":this.sjKzr,
        "zzKzr":this.zzKzr,
        "businessNature":this.businessNature,
        "employee":this.employee,
        "ssTime":this.ssTime,
        "business":this.business,
        "workBusiness":this.workBusiness,
        "shouru":this.shouru,
        "projectType":this.projectType,
        "projectName":this.projectName,
        "businessScope":this.businessScope,
        "note":this.note
      }
      loading("请求中")
      axiosPostJson(DO_NET_URL+"company/AddCompany",json,function (res){
        closeLoading()
        if(res.code==200){
          toask("添加成功",6)
          setTimeout(function (){
            that.$emit("send",'companyList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback() {
      this.$emit("send", 'companyList')
    },

  }
}
</script>

<style scoped>
.boxText {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 50%;
}

.leftTd {
  text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 700;
  width: 120px
}

.addBtn {
  color: #1890ff;
  background: #e8f4ff;
  border: 1px solid #1890ff;
  cursor: pointer;
  float: left;
  font-size: 12px;
  padding: 7px 15px;
  border-radius: 3px;
}

.th {
  border-bottom: 1px solid #dfe6ec;
  text-align: left;
  padding: 0 10px;
  word-break: break-word;
  background-color: #f8f8f9;
  color: #515a6e;
  height: 40px;
  font-size: 12px;
}

.td {
  border-bottom: 1px solid #dfe6ec;
  padding: 0 10px;
  word-break: break-word;
  background-color: #ffffff;
  color: #606266;
  height: 40px;
  font-size: 12px;
}
</style>